import * as React from 'react';

function SvgCog(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M21.69 12A4.08 4.08 0 0124 8.51a12.53 12.53 0 00-1-2.39 3.85 3.85 0 01-3.87-1.26 3.73 3.73 0 01-1-3.87 12.27 12.27 0 00-2.39-1A4.5 4.5 0 0112 2.31 4.53 4.53 0 018.22 0a12.44 12.44 0 00-2.38 1 3.75 3.75 0 01-1 3.87A3.85 3.85 0 011 6.12a12.53 12.53 0 00-1 2.39A4.08 4.08 0 012.31 12 4.53 4.53 0 010 15.78a12.44 12.44 0 001 2.38 3.75 3.75 0 013.87 1 3.75 3.75 0 011 3.87 12.27 12.27 0 002.39 1A4.5 4.5 0 0112 21.69 4.53 4.53 0 0115.78 24a12.44 12.44 0 002.38-1 3.75 3.75 0 011-3.87A3.85 3.85 0 0123 17.88a12.53 12.53 0 001-2.39A4.08 4.08 0 0121.69 12zM12 17.22A5.22 5.22 0 1117.22 12 5.22 5.22 0 0112 17.22z" />
    </svg>
  );
}

const MemoSvgCog = React.memo(SvgCog);
export default MemoSvgCog;
